import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../api/axiosInstance";
import {
  FaChevronDown,
  FaChevronLeft,
  FaFileInvoice,
  FaUser,
  FaShoppingCart,
  FaHeadset,
  FaDollarSign,
  FaEdit,
  FaSignOutAlt,
  FaUserCircle,
  FaCheckCircle,
  FaImage,
  FaChartLine
} from "react-icons/fa";
import DashboardLayout from "./DashboardLayout";
import jwt_decode from "jwt-decode";
import { getCustomerInfo } from "../services/customerService";

const DashboardCard = ({ icon: Icon, title }) => (
  <div className="bg-white rounded-2xl shadow-md p-6 flex flex-col items-center justify-center hover:shadow-lg transition">
    <Icon className="text-blue-700 text-3xl mb-3" />
    <h3 className="text-blue-900 font-bold text-sm">{title}</h3>
  </div>
);

const UserDashboard = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const [customer, setCustomer] = useState(null);

  useEffect(() => {
    // debugger;
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login"); // یا مسیر لاگین شما
    }

    // const response = axios.get(
    //   "https://localhost:7201/api/Customer/AddCustomer",
    //   {
    //     headers: {
    //       Authorization: `Bearer ${token}`,
    //     },
    //   }
    // );

    const fetchCustomers = async () => {
      try {
        // debugger;
        const token = localStorage.getItem("token");
        //console.log("توکن از localStorage:", token);
        // const response = await axios.get(
        //   "http://172.30.11.101:5050/api/Customer/CustomerInfo",
        //   {
        //     headers: {
        //       Authorization: `Bearer ${token}`,
        //     },
        //     withCredentials: true, // ⬅️ شاید اضافه کردن این مورد هم مهم باشه
        //   }
        // );
        // const response = await axios.get("/Customer/CustomerInfo");
        const response = await getCustomerInfo();
        setCustomer(response.data);
      } catch (error) {
        console.error("خطا در گرفتن لیست مشتری‌ها:", error);
      }
    };

    fetchCustomers();
  }, []);

  const customerName = customer?.customerName || "";
  const customerId = customer ? `کد مشتری: ${customer.customerCode}` : "";

 
  const DashboardCard = ({ icon: Icon, title, onClick }) => (
    <div
      className="bg-white rounded-2xl shadow-md p-6 flex flex-col items-center justify-center hover:shadow-lg transition cursor-pointer"
      onClick={onClick}
    >
      <Icon className="text-blue-700 text-3xl mb-3" />
      <h3 className="text-blue-900 font-bold text-sm">{title}</h3>
    </div>
  );

  return (
    <DashboardLayout customer={customer}>
      {/* بنر بالای صفحه */}
      <div className="mb-6">
        {/* دسکتاپ */}
        <img
          src={require("../assets/ShunaWeb.jpg")} // مسیر بنر دسکتاپ
          alt="بنر دسکتاپ"
          className="hidden md:block w-full rounded-lg shadow"
        />
        {/* موبایل */}
        <img
          src={require("../assets/ShunaMobile.jpg")} // مسیر بنر موبایل
          alt="بنر موبایل"
          className="block md:hidden w-full rounded-lg shadow"
        />
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-6">
        <DashboardCard
          icon={FaUser}
          title="اطلاعات مشتری"
          onClick={() =>
            navigate("/customer-info", {
              state: { customer },
            })
          }
        />
        <DashboardCard
          icon={FaFileInvoice}
          title="فاکتورها"
          onClick={() =>
            navigate("/customer-invoices", {
              state: { customer },
            })
          }
        />
        <DashboardCard
          icon={FaDollarSign}
          title="مالی"
          onClick={() =>
            navigate("/financial-info", {
              state: { customer },
            })
          }
        />

        <DashboardCard
          icon={FaEdit}
          title="فاکتور برگشتی"
          onClick={() =>
            navigate("/returnInvoice-info", {
              state: { customer },
            })
          }
        />

         <DashboardCard
          icon={FaChartLine}
          title="گزارش خرید"
          onClick={() =>
            navigate("/sales-report", {
              state: { customer },
            })
          }
        />
        <DashboardCard
          icon={FaImage}
          title="کاتالوگ محصول"
          onClick={() =>
            navigate("/product-image", {
              state: { customer },
            })
          }
        />
        <DashboardCard
          icon={FaCheckCircle}
          title="اعلانات و شکایات"
          onClick={() =>
            navigate("/complaints-list", {
              state: { customer },
            })
          }
        />
       
        <DashboardCard
          icon={FaHeadset}
          title="ارتباط با ما"
          onClick={() =>
            navigate("/contact-us", {
              state: { customer },
            })
          }
        />
      </div>
    </DashboardLayout>
  );
};

export default UserDashboard;
